import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { breakpoints, DrawerContext, theme } from '@notino/react-styleguide';

import { Hidden } from '@components/Hidden';
import messages from '@components/Universals/WishlistModifier/messages';
import { styled } from '@linaria/react';
import { ellipsis } from '@styles/common';

import { Content } from './Content';

const Header = styled.div`
  ${theme.typography.labelLarge}
  text-align: center;
  ${ellipsis}

  @media (min-width: ${breakpoints.md}) {
    margin-left: 1rem;
  }
`;

export const useNewListDrawer = () => {
  const { openDrawer } = DrawerContext.useDrawerContext();

  return {
    open: () => {
      openDrawer(<Content />, {
        title: (
          <>
            <Hidden breakpoint="md">
              <div style={{ width: 52 }} />
            </Hidden>
            <Header>
              <FormattedMessage {...messages.newListDrawerTitle} />
            </Header>
          </>
        ),
        hideScrollbar: true,
        initialPosition: 'dynamic',
        showFade: false,
        headerCustomStyles: 'list-menu-drawer-header',
      });
    },
  };
};
